import {Turbo} from "@hotwired/turbo-rails";
import {get} from "@rails/request.js";

import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

import "chartkick/chart.js";

import "./controllers";

// More responsive feeling in clicking links
Turbo.setProgressBarDelay(100);

/**
 * Create custom events from the Rails Server Side
 * <%= turbo_stream.action(:dispatch_custom_event, 'calendar:render') %>
 */
Turbo.StreamActions.dispatch_event = function () {
  console.log("Dispatch Event: ", this.getAttribute("event_name"));

  window.dispatchEvent(new Event(this.getAttribute("event_name")));
};


/**
 * Visit a URL from the stream action
 */
Turbo.StreamActions.visit = function () {
  const url = this.getAttribute('url') || '/'
  const format = this.getAttribute('format') || '/'
  const delay = this.getAttribute('delay') || 0;
  // Turbo.visit(url, { frame: '_top', action: 'advance' })

  if (format === "turbo_stream") {
    setTimeout(() => {
      console.log("Making turbo stream visit");
      get(url, {responseKind: "turbo-stream"});
    }, delay);
    return;
  }

  setTimeout(() => {
    Turbo.visit(url);
  }, delay);
}

/**
 * Submit a form with a delay
 */
Turbo.StreamActions.submit_form = function () {
  const form_id = this.getAttribute('form_id')
  const delay = this.getAttribute('delay') || 0;

  if (form_id == null) {
    return;
  }

  setTimeout(() => {
    document.getElementById(form_id).requestSubmit();
  }, delay);
}

/**
 * Reload the page duh
 */
Turbo.StreamActions.reload = function () {
  const delay = this.getAttribute('delay') || 0;

  setTimeout(() => {
    window.location.reload();
  }, delay);
}

/**
 * Set an attribute on a HTML element
 */
Turbo.StreamActions.set_attribute = function () {
  const selector = this.getAttribute('selector');
  const attribute = this.getAttribute('attribute');
  const value = this.getAttribute('value');

  if (selector == null) {
    return;
  }

  document.querySelectorAll(selector).forEach(element => {
    element.setAttribute(attribute, value);
  });
}

/**
 * Remove an attribute from a HTML element
 */
Turbo.StreamActions.remove_attribute = function () {
  const selector = this.getAttribute('selector');
  const attribute = this.getAttribute('attribute');

  if (selector == null) {
    return;
  }

  document.querySelectorAll(selector).forEach(element => {
    element.removeAttribute(attribute);
  });
}
